import curry from "../../lib/core/functional/curry";

const renderModule = curry(function renderModule(preact, _context, _deps, _altLoader) {
    const { h } = preact;
    function ActionButton({ label, callback }) {
        return (
            <a onClick={callback} href="javascript:;" class="btn">
                {label}
            </a>
        );
    }

    function makeActionButton(action) {
        if (action) {
            return <ActionButton {...action} />;
        } else {
            return null;
        }
    }

    function Module({ title, body, possitiveAction, negativeAction, className }) {
        return (
            <div class={`informers info${className ? ` ${className}` : ""}`}>
                <div class="infrms">
                    <div class="hdr">{title}</div>
                    <div class="wrp">
                        <div class="data">{body}</div>
                        <div class="controls">
                            {makeActionButton(possitiveAction)}
                            {makeActionButton(negativeAction)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return Module;
});

export default function informerModule({ preact }) {
    return renderModule(preact);
}
